var _rect, _path, _circle, _circle2, _circle3, _rect2, _path2, _ellipse, _ellipse2, _ellipse3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 41,
    viewBox: "0 0 56 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 48,
    height: 28,
    rx: 14,
    fill: "#292F40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4115 30.2594L46.2787 27.0363L52.1364 23.3367L52.4115 30.2594Z",
    fill: "#292F40"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 14,
    r: 2,
    fill: "#E0FFEC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 14,
    r: 2,
    fill: "#E0FFEC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 14,
    r: 2,
    fill: "#E0FFEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 21.907,
    rx: 10.9535,
    transform: "matrix(-1 0 0 1 38 15)",
    fill: "url(#paint0_linear_1216_1476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24725 38.4011L8.04628 35.9085L3.46254 33.0474L3.24725 38.4011Z",
    fill: "#7428F0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5417,
    cy: 26.2225,
    rx: 1.74701,
    ry: 1.72655,
    fill: "#EDFCFE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7831,
    cy: 26.2225,
    rx: 1.74701,
    ry: 1.72655,
    fill: "#EDFCFE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0241,
    cy: 26.2225,
    rx: 1.74701,
    ry: 1.72655,
    fill: "#EDFCFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1216_1476",
    x1: 38,
    y1: 11,
    x2: -7.39716e-8,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7945E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4568E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd8552da30772f315f5c49b91644e787.svg";
export { ForwardRef as ReactComponent };